import { createFileRoute } from "@tanstack/react-router";
import { AuthRoute } from "@features/auth/AuthRoute";

export const Route = AuthRoute;
